// extracted by mini-css-extract-plugin
module.exports = {"feedbackFormModal":"_2Yka7W","feedbackLink":"_1NSRlA","feedbackQuestion":"_1Tw9sU","feedbackFormDropList":"_1pcL9E","feedbackFormContinue":"_2t9xh6"};